import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PreQualifierProvider } from "@/context/PreQualifierContext";
import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ApplicationDetail from "@/pages/ApplicationDetail";
import LenderSignup from "@/pages/LenderSignup";
import LenderLogin from "@/pages/LenderLogin";
import LenderLanding from "@/pages/LenderLanding";
import LenderDashboard, { LenderDealDetail } from "@/pages/LenderDashboard";
import CitySectorLanding from "@/pages/CitySectorLanding";
import BusinessLoansRoute from "@/pages/BusinessLoansRoute";
import CaseStudy from "@/pages/CaseStudy";
import InsightArticle, { InsightsIndex } from "@/pages/Insights";
import ScrollToHash from "@/components/ScrollToHash";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PreQualifierProvider>
          <ScrollToHash />
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/apply/resume/:token" element={<Apply />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/applications/:id" element={<ApplicationDetail />} />
            <Route path="/lenders" element={<LenderLanding />} />
            <Route path="/lender/signup" element={<LenderSignup />} />
            <Route path="/lender/login" element={<LenderLogin />} />
            <Route path="/lender" element={<LenderDashboard />} />
            <Route path="/lender/deals/:id" element={<LenderDealDetail />} />
            <Route path="/business-loans/:slug" element={<BusinessLoansRoute />} />
            <Route path="/business-finance/:sector" element={<CitySectorLanding kind="sector" />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
            <Route path="/insights" element={<InsightsIndex />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
          </Routes>
        </PreQualifierProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
